<button [type]="type()" [class]="classes()" [disabled]="disabled() || loading()" [tooltip]="tooltip() || (iconOnly() ? label() : '')" (click)="clicked.emit(); triggerRipple($event)">
  @if (loading()) {
    <span class="w-4 h-4 border-2 border-current border-r-transparent rounded-full animate-spin shrink-0"></span>
    @if (!iconOnly()) { <span>Loading...</span> }
  } @else {
    @if (icon() && (iconOnly() || iconPosition() === 'left')) {
      <lucide-icon [img]="icon()!" [size]="iconSize()" />
    }
    @if (!iconOnly() && label()) {
      <span>{{ label() }}</span>
    }
    @if (icon() && !iconOnly() && iconPosition() === 'right') {
      <lucide-icon [img]="icon()!" [size]="iconSize()" />
    }
  }
</button>
